// extracted by mini-css-extract-plugin
module.exports = {"tags":"index--tags--3t5jU","tags__item":"index--tags__item--WnPlM","item__text":"index--item__text--9XaRW"};